import Vue from 'vue';
import {formatDate, isValidDate} from "@/modules/common.js";

Vue.filter('interval', dates => dates
  .map(date => new Date(date))
  .filter(isValidDate)
  .map(formatDate)
  .join(' - ')
);
